import styled from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import {
  inputgray,
  white,
  whitegray,
  bordergray,
  gold,
  black,
  red
} from '../../styles/colors'

export const Row = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background: ${props => (props.currentUser ? whitegray : white)};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  margin-bottom: 0.75rem;
  padding-top: 1rem;

  ${minmedia.medium`
    padding-top: 1.5rem;
  `} ${minmedia.large`
    padding: ${props => (props.noPadding ? '0' : '1.25rem 0')};
    margin-bottom: .5rem;
  `};
`

export const Item = styled.div`
  width: 100%;
  padding: 1rem;
  padding-top: 0;
  overflow: hidden;

  &:last-child {
    padding: 0; //reset
  }

  ${minmedia.medium`
    width: 50%;
    padding-bottom: 1.5rem;
  `}
  ${minmedia.large`
    width: calc(100%/4 - 80px);
    padding: 0; //reset

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      width: 80px;
    }
  `}
`

export const Sup = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  color: ${inputgray};
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;

  ${minmedia.medium`
    font-size: 14px;
  `} ${minmedia.large`
    display: none;
  `};
`

export const DotsContainer = styled.div`
  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${inputgray};
  }

  &:hover {
    svg {
      fill: ${gold};
    }
  }
`

export const Button = styled.div`
  ${maxmedia.large`
    position: absolute;
    top: 0;
    right: 0;
    padding: .5rem 1rem;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  `} ${maxmedia.medium`
    top: 0;
    right: 0;
    height: auto;
    padding: 1rem 1.25rem;
    svg {
      width: 1.25rem
      height: 1.25rem;
    }
  `} ${minmedia.large`
    padding: 1.25rem 1rem;
    border-left: 1px solid ${bordergray};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  `};
  &:hover {
    transition: background 0.3s;
    cursor: pointer;
    background: ${bordergray};
    svg {
      fill: ${black};
    }
  }
`

export const IconContainer = styled.div`
  svg {
    transition: fill 0.3s;
    width: 1.5rem;
    height: 1.5rem;
    fill: ${red};
  }
`


// WEBPACK FOOTER //
// ./src/components/OrderTableRow/styles.js